"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const v4_1 = require("zod/v4");
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    loanProductSlug: v4_1.z.string().describe('Loan product slug'),
    creditFacilitySlug: v4_1.z.string().describe('Credit facility slug'),
});
exports.nodeType = 'file_assignedRepaymentTape';
exports.IntermediateRecordConfigSchema = v4_1.z.object({});
exports.artifactType = 'assignedRepaymentTape';
//# sourceMappingURL=types.js.map